import React from 'react';
import { Star, CheckCircle, ShieldCheck } from 'lucide-react';
const TESTIMONIALS = [{
  text: "Leí esta guía en una noche y al día siguiente ya sabía qué decirle a mi mamá. Por primera vez en meses, ella me dijo: 'Gracias por entenderme.' No saben lo que eso significa.",
  author: 'María G.',
  role: 'Hija de paciente con cáncer de mama',
  date: 'hace 2 días',
  initials: 'MG',
  color: 'bg-purple-100 text-purple-700'
}, {
  text: 'Estaba tan perdido que casi ni la visitaba porque no sabía qué decir. Esta guía me devolvió el valor de estar ahí. Mi esposa nota la diferencia.',
  author: 'Roberto M.',
  role: 'Esposo de paciente con cáncer',
  date: 'hace 5 días',
  initials: 'RM',
  color: 'bg-blue-100 text-blue-700'
}, {
  text: 'Lo que más me ayudó fue el módulo del equipo familiar. Organizamos turnos, roles, todo. Mi mamá ya no se siente sola y nosotros ya no estamos agotados.',
  author: 'Carmen L.',
  role: 'Hija mayor de familia con 4 hermanos',
  date: 'hace 1 semana',
  initials: 'CL',
  color: 'bg-teal-100 text-teal-700'
}];
function StarRating({
  count = 5,
  size = 20,
  className = ''
}: {
  count?: number;
  size?: number;
  className?: string;
}) {
  return <div className={`flex gap-1 ${className}`} data-id="element-267">
      {[...Array(5)].map((_, i) => <div key={i} className={`relative ${i < count ? 'bg-[#D4A017]' : 'bg-gray-200'}`} style={{
      width: size,
      height: size,
      clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)'
    }} data-id="element-268" />)}
    </div>;
}
function TrustpilotHeader() {
  return <div className="flex flex-col items-center justify-center mb-12 text-center" data-id="element-269">
      <h2 className="text-[28px] sm:text-[32px] font-[800] text-[#1A1035] font-['Montserrat'] mb-4" data-id="element-270">
        Lo que dicen las familias
      </h2>

      <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6" data-id="element-271">
        <div className="flex flex-col items-center sm:items-end" data-id="element-272">
          <span className="text-[32px] font-bold text-[#1A1035] leading-none" data-id="element-273">
            Excelente
          </span>
          <div className="flex items-center gap-2 mt-1" data-id="element-274">
            <StarRating size={24} data-id="element-275" />
          </div>
        </div>

        <div className="hidden sm:block w-px h-16 bg-gray-200" data-id="element-276"></div>

        <div className="flex flex-col items-center sm:items-start text-center sm:text-left" data-id="element-277">
          <span className="text-[14px] text-gray-600 font-medium" data-id="element-278">
            Basado en{' '}
            <span className="font-bold text-[#1A1035] underline decoration-2 decoration-[#00B67A]/30" data-id="element-279">
              127 reseñas
            </span>
          </span>
          <div className="flex items-center gap-1 mt-1" data-id="element-280">
            <ShieldCheck size={16} className="text-[#00B67A]" data-id="element-281" />
            <span className="text-[12px] text-gray-500 font-medium" data-id="element-282">
              Reseñas verificadas
            </span>
          </div>
        </div>
      </div>
    </div>;
}
function ReviewCard({
  review
}: {
  review: (typeof TESTIMONIALS)[0];
}) {
  // Extract title from first sentence or first few words
  const title = review.text.split('.')[0].substring(0, 40) + (review.text.split('.')[0].length > 40 ? '...' : '');
  return <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col h-full" data-id="element-283">
      <div className="mb-4" data-id="element-284">
        <StarRating size={18} data-id="element-285" />
      </div>

      <h3 className="font-bold text-[#1A1035] text-lg mb-2 font-['Montserrat'] leading-tight" data-id="element-286">
        "{title}"
      </h3>

      <p className="text-gray-600 text-[14px] leading-relaxed mb-6 flex-grow font-['Poppins']" data-id="element-287">
        {review.text}
      </p>

      <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-288">
        <div className="flex items-center justify-between mb-1" data-id="element-289">
          <div className="font-bold text-[#1A1035] text-[14px] flex items-center gap-1.5" data-id="element-290">
            {review.author}
            <CheckCircle size={14} className="text-[#00B67A] fill-[#00B67A]/10" data-id="element-291" />
          </div>
          <span className="text-[12px] text-gray-400" data-id="element-292">{review.date}</span>
        </div>
        <div className="text-[11px] text-gray-500 font-medium truncate" data-id="element-293">
          {review.role}
        </div>
      </div>
    </div>;
}
export function TestimonialCarousel() {
  return <section className="py-[60px] px-[15px] bg-[#F9FAFB]" data-id="element-294">
      <div className="container max-w-[1100px] mx-auto" data-id="element-295">
        <TrustpilotHeader data-id="element-296" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-297">
          {TESTIMONIALS.map((testimonial, index) => <ReviewCard key={index} review={testimonial} data-id="element-298" />)}
        </div>
      </div>
    </section>;
}